// Contenido centralizado de la landing (en español). Imágenes servidas desde Cloudflare R2.

const R2 = "https://photos.leonowak.org/site";

export const NAV_LINKS = [
  { id: "inicio", label: "Inicio" },
  { id: "club", label: "El Club" },
  { id: "historia", label: "Historia" },
  { id: "equipos", label: "Equipos" },
  { id: "plantel", label: "Plantel" },
  { id: "apps", label: "Apps" },
  { id: "socios", label: "Socios" },
  { id: "tienda", label: "Tienda" },
];

export const STATS = [
  { value: "50", label: "Años de historia", suffix: "" },
  { value: "800", label: "Socios activos", suffix: "+" },
  { value: "32", label: "Títulos oficiales", suffix: "" },
  { value: "4", label: "Categorías", suffix: "" },
];

// --- Hero: accesos rápidos a secciones + novedades ---
export const HERO_SECTIONS = [
  { id: "plantel", label: "Plantel", icon: "users" },
  { id: "equipos", label: "Fútbol", icon: "shirt" },
  { id: "historia", label: "Historia", icon: "history" },
  { id: "galeria", label: "Galería", icon: "image" },
  { id: "tienda", label: "Tienda", icon: "bag" },
  { id: "socios", label: "Socios", icon: "star" },
];

export const HERO_SLIDES = [`${R2}/hero-1.jpg`, `${R2}/hero-2.jpg`, `${R2}/hero-3.jpg`, `${R2}/hero-4.jpg`];

export const NOVEDADES = [
  { tag: "Próximo partido", title: "Primera vs. Atlético — Dom. 15:30", target: "equipos" },
  { tag: "Tienda oficial", title: "Nueva colección 50 años disponible", target: "tienda" },
  { tag: "Escuela infantil", title: "Inscripciones 2026 abiertas", target: "equipos" },
];

// --- Intro / storytelling del club ---
export const NOSOTROS = {
  lead: "Más que un club de fútbol, somos un punto de encuentro. Desde 1976, generaciones enteras crecieron, hicieron amigos y celebraron alrededor de esta camiseta. Esta es, en pocas líneas, nuestra esencia.",
  blocks: [
    { icon: "history", title: "Nuestra historia", text: "Medio siglo de pasión nacido del esfuerzo de un puñado de vecinos. Una identidad que se transmite de padres a hijos." },
    { icon: "field", title: "Nuestra cancha", text: "Dos campos de juego, iluminación y vestuarios renovados. El escenario donde se escriben los domingos del club." },
    { icon: "fans", title: "Nuestra hinchada", text: "El alma del Comandante. Familias que alientan, viajan y hacen flamear los colores en cada partido." },
    { icon: "infra", title: "Nuestra infraestructura", text: "Quincho, sede social, buffet y predio deportivo pensados para que el club sea la segunda casa de cada socio." },
  ],
};

export const APPS = [
  {
    id: "socios",
    title: "Socios & Quincho",
    desc: "Administrá la membresía del club y reservá el quincho para tus eventos en segundos. Roles de Administrador y Socio con permisos diferenciados.",
    features: ["Gestión de socios y cuotas", "Reserva del quincho (parrilla / eventos)", "Roles Admin y Socio", "Estados de cuota al día"],
    cta: "Acceder", available: true, badge: "Admin + Socio",
    image: `${R2}/app-socios.jpg`,
  },
  {
    id: "jugadores",
    title: "Gestión de Jugadores",
    desc: "Fichas completas, categorías, asistencia y rendimiento de cada jugador del club en un solo panel.",
    features: ["Fichas y categorías", "Control de asistencia", "Datos médicos y de contacto", "Seguimiento de planteles"],
    cta: "Próximamente", available: false, badge: "Cuerpo técnico",
  },
  {
    id: "canchas",
    title: "Reserva de Canchas",
    desc: "Calendario de canchas en tiempo real. Evitá superposiciones y organizá entrenamientos y partidos sin fricción.",
    features: ["Calendario en tiempo real", "Reservas por categoría", "Disponibilidad instantánea", "Notificaciones automáticas"],
    cta: "Próximamente", available: false, badge: "Tiempo real",
  },
];

export const PRODUCTS = [
  { name: "Camiseta Oficial Titular", price: "$ 28.900", tag: "Temporada 2026", image: `${R2}/prod-titular.jpg` },
  { name: "Camiseta Edición 50 Años", price: "$ 34.500", tag: "Aniversario", image: `${R2}/prod-50.jpg` },
  { name: "Buzo Entrenamiento", price: "$ 41.200", tag: "Indumentaria", image: `${R2}/prod-buzo.jpg` },
  { name: "Bufanda del Hincha", price: "$ 12.900", tag: "Accesorios", image: `${R2}/prod-bufanda.jpg` },
];

export const TIMELINE = [
  { year: "1976", title: "Fundación", text: "Un grupo de vecinos funda el Club Comandante Leo Nowak con el sueño de unir al barrio a través del fútbol." },
  { year: "1984", title: "Primera Cancha Propia", text: "El club inaugura su primer campo de juego propio, hito que marca el crecimiento institucional." },
  { year: "1995", title: "Nace la Escuela Infantil", text: "Se crea la Escuela Infantil de Fútbol, base formativa de las futuras generaciones del club." },
  { year: "2008", title: "Ascenso Histórico", text: "El plantel de Primera logra un ascenso recordado por toda la comunidad del club." },
  { year: "2018", title: "Nuevo Quincho y Sede Social", text: "Se inaugura el quincho y el espacio social para eventos, encuentros y celebraciones de los socios." },
  { year: "2026", title: "50° Aniversario", text: "Medio siglo de pasión, identidad y comunidad. Celebramos las bodas de oro del club." },
];

export const HISTORIA_IMG = `${R2}/historia/historia.jpg`;

export const PALMARES = [
  { count: "12", label: "Títulos de Liga" },
  { count: "8", label: "Copas Provinciales" },
  { count: "6", label: "Torneos Infantiles" },
  { count: "6", label: "Campeonatos Senior" },
];

export const HONORS = [
  { year: "2008", title: "Campeón de Liga — Primera División", tier: "oro" },
  { year: "2012", title: "Copa Provincial", tier: "plata" },
  { year: "2016", title: "Campeón Torneo Juvenil", tier: "bronce" },
  { year: "2021", title: "Campeón Senior Regional", tier: "oro" },
  { year: "2023", title: "Subcampeón Copa de Oro", tier: "plata" },
  { year: "2025", title: "Campeón Escuela Infantil", tier: "bronce" },
];

// --- Plantel / cuerpo técnico (Meet our team) ---
export const PLANTEL = [
  { name: "Martín Ríos", role: "Delantero", number: "9", intro: "Goleador histórico de la última década. Símbolo de garra y entrega.", img: `${R2}/plantel-1.jpg` },
  { name: "Diego Ferrari", role: "Arquero", number: "1", intro: "Capitán y último bastión del arco. Atajadas que valen campeonatos.", img: `${R2}/plantel-2.jpg` },
  { name: "Lucas Romero", role: "Mediocampista", number: "10", intro: "El cerebro del equipo. Visión de juego y pegada de media distancia.", img: `${R2}/plantel-3.jpg` },
  { name: "Sofía Méndez", role: "Preparadora Física", number: null, intro: "Detrás del rendimiento del plantel. Ciencia y trabajo aplicados al fútbol.", img: `${R2}/plantel-4.jpg` },
  { name: "Tano Bianchi", role: "Director Técnico", number: null, intro: "Formado en el club, hoy dirige al plantel mayor con identidad propia.", img: `${R2}/plantel-5.jpg` },
  { name: "Joaquín Sosa", role: "Lateral", number: "6", intro: "Recorre la banda de punta a punta. Pulmón inagotable.", img: `${R2}/plantel-6.jpg` },
  { name: "Tomás Aguirre", role: "Volante", number: "8", intro: "Equilibrio y sacrificio en el medio. La marca registrada del club.", img: `${R2}/plantel-7.jpg` },
  { name: "Bruno Vega", role: "Defensor Central", number: "4", intro: "Temple y juego aéreo. Líder de la última línea.", img: `${R2}/plantel-8.jpg` },
];

export const EQUIPOS = [
  { id: "escuela", name: "Escuela Infantil", age: "5 a 12 años",
    desc: "La base del club. Formamos a los más chicos en valores, técnica y amor por la camiseta en un ambiente seguro y divertido.",
    points: ["Entrenamientos 3 veces por semana", "Profes formadores certificados", "Encuentros y festivales infantiles"],
    image: `${R2}/equipos/escuela.jpg` },
  { id: "juvenil", name: "Categoría Juvenil", age: "13 a 19 años",
    desc: "El semillero competitivo del club. Desarrollo deportivo y humano para dar el salto a la Primera.",
    points: ["Competencia en liga juvenil", "Preparación física integral", "Seguimiento de rendimiento"],
    image: `${R2}/equipos/juvenil.jpg` },
  { id: "primera", name: "Primera División", age: "Plantel mayor",
    desc: "La cara competitiva del club. Representa la identidad y la pasión del Comandante Leo Nowak cada fin de semana.",
    points: ["Liga oficial de primera", "Cuerpo técnico profesional", "Doble turno de entrenamiento"],
    image: `${R2}/equipos/primera.jpg` },
  { id: "senior", name: "Categoría Senior", age: "+35 años",
    desc: "La experiencia y la amistad reunidas en la cancha. Fútbol, salud y tercer tiempo en el quincho del club.",
    points: ["Liga senior amistosa", "Fútbol recreativo y competitivo", "Encuentros sociales en el quincho"],
    image: `${R2}/equipos/senior.jpg` },
];

// --- Comisión Directiva agrupada (tabs) con descripción para el flip ---
export const COMISION_GROUPS = [
  {
    id: "mesa", label: "Mesa Directiva",
    members: [
      { name: "Roberto Méndez", role: "Presidente", desc: "Socio hace 30 años. Lidera el proyecto institucional del club." },
      { name: "Laura Giménez", role: "Vicepresidenta", desc: "Impulsora del fútbol femenino y los espacios sociales." },
      { name: "Carlos Acosta", role: "Secretario General", desc: "Coordina la administración y las actas de la institución." },
      { name: "Marta Sosa", role: "Prosecretaria", desc: "Acompaña la gestión administrativa y de socios." },
      { name: "Daniel Ferreyra", role: "Tesorero", desc: "Responsable de las finanzas y la transparencia del club." },
      { name: "Verónica Luna", role: "Protesorera", desc: "Apoya el control económico y la gestión de cuotas." },
    ],
  },
  {
    id: "vocales", label: "Vocales",
    members: [
      { name: "Jorge Benítez", role: "Vocal Titular 1°", desc: "Encargado del mantenimiento del predio deportivo." },
      { name: "Andrea Ríos", role: "Vocal Titular 2°", desc: "Coordina eventos sociales y el quincho del club." },
      { name: "Pablo Cáceres", role: "Vocal Titular 3°", desc: "Nexo con las categorías juveniles." },
      { name: "Silvia Romero", role: "Vocal Titular 4°", desc: "Gestión de la tienda y la indumentaria oficial." },
      { name: "Hugo Domínguez", role: "Vocal Titular 5°", desc: "Logística de partidos y traslados del plantel." },
      { name: "Natalia Vera", role: "Vocal Titular 6°", desc: "Relaciones con la comunidad y los sponsors." },
      { name: "Eduardo Pérez", role: "Vocal Suplente 1°", desc: "Colabora en obras e infraestructura." },
      { name: "Claudia Ortiz", role: "Vocal Suplente 2°", desc: "Apoyo en la organización de eventos." },
      { name: "Raúl Medina", role: "Vocal Suplente 3°", desc: "Asistencia general a la comisión." },
      { name: "Gabriela Núñez", role: "Vocal Suplente 4°", desc: "Comunicación interna con los socios." },
    ],
  },
  {
    id: "areas", label: "Fiscalización & Áreas",
    members: [
      { name: "Sergio Ledesma", role: "Revisor de Cuentas 1°", desc: "Control y auditoría de las finanzas del club." },
      { name: "Mónica Aguirre", role: "Revisor de Cuentas 2°", desc: "Verificación de balances y rendiciones." },
      { name: "Fernando Quiroga", role: "Revisor Suplente", desc: "Apoyo al órgano de fiscalización." },
      { name: "Patricia Coronel", role: "Directora Deportiva", desc: "Lidera el proyecto deportivo de todas las categorías." },
      { name: "Marcelo Ávila", role: "Director de Prensa", desc: "Comunicación, redes y contenido del club." },
      { name: "Lucía Maldonado", role: "Coord. Fútbol Infantil", desc: "Responsable de la Escuela Infantil de Fútbol." },
    ],
  },
];

export const TIERS = [
  { name: "Oro", color: "#d4a017", price: "$ 9.500 / mes", desc: "La membresía más completa para el hincha de alma.",
    perks: ["Acceso a todas las apps", "Reserva prioritaria del quincho", "Descuentos en la tienda", "Entradas preferenciales"], highlight: true },
  { name: "Plata", color: "#9e9e9e", price: "$ 6.500 / mes", desc: "Todos los beneficios esenciales para disfrutar del club.",
    perks: ["Acceso a apps de socios", "Reserva del quincho", "Descuentos seleccionados", "Acceso a eventos"], highlight: false },
  { name: "Bronce", color: "#cd7f32", price: "$ 3.900 / mes", desc: "El primer paso para ser parte de la familia del club.",
    perks: ["Carnet de socio", "Acceso al predio", "Novedades del club", "Participación en sorteos"], highlight: false },
];

export const TESTIMONIALS = [
  { name: "Marcela D.", role: "Socia hace 18 años", text: "El club es mi segunda casa. Ahora reservar el quincho para los cumpleaños se hace en dos minutos desde el celular." },
  { name: "Gustavo P.", role: "Padre Escuela Infantil", text: "Mis dos hijos crecieron jugando acá. Los valores que aprenden valen tanto como los goles." },
  { name: "Ernesto L.", role: "Categoría Senior", text: "50 años no es poco. Seguir compartiendo cancha y asado con los mismos amigos no tiene precio." },
];

export const FAQS = [
  { q: "¿Cómo me asocio al club?", a: "Acercate a la sede social con tu DNI o completá el formulario de socios online. Elegís tu categoría (Oro, Plata o Bronce) y en el día quedás registrado." },
  { q: "¿Cómo reservo el quincho?", a: "Desde la app de Socios & Quincho podés ver la disponibilidad en tiempo real y reservar la parrilla o el espacio de eventos según tu categoría de socio." },
  { q: "¿Qué categorías de fútbol tiene el club?", a: "Contamos con Escuela Infantil (5 a 12 años), Categoría Juvenil (13 a 19), Primera División y Categoría Senior (+35 años)." },
  { q: "¿Los chicos pueden probarse en la Escuela Infantil?", a: "Sí. Realizamos jornadas de prueba abiertas durante todo el año. Coordiná tu día contactando a la coordinación de fútbol infantil." },
  { q: "¿Dónde compro la indumentaria oficial?", a: "En la sección Tienda del sitio y en la sede del club. Los socios Oro y Plata acceden a descuentos exclusivos." },
  { q: "¿El club tiene actividades sociales además del fútbol?", a: "Por supuesto. El quincho y la sede social son el corazón del club: cumpleaños, peñas, asados y eventos para toda la familia." },
];
